import { StyleSheet, View, type ViewProps } from 'react-native';

export type XStackProps = ViewProps;

export function XStack({ style, accessibilityRole = 'none', ...props }: XStackProps) {
  return <View {...props} accessibilityRole={accessibilityRole} style={[styles.xstack, style]} />;
}

const styles = StyleSheet.create({
  xstack: {
    flexDirection: 'row',
  },
});
